import { Card, Typography } from 'antd'

export default function RegistrationSuccess() {
  const params = new URLSearchParams(window.location.search)
  return (
    <div className='signup-form'>
      <Typography.Title
        className='course-name'
        level={3}
        style={{ marginBottom: 40, marginTop: 40 }}
      >
        {params.get('course_name')}
      </Typography.Title>
      <Card variant='outlined' style={{ maxWidth: 350, margin: '40px auto auto' }}>
        <Typography.Title level={3}>
          {new URLSearchParams(window.location.search).get('waitlist') ===
          'true'
            ? 'You have been added to the waitlist'
            : 'Successful registration'}
        </Typography.Title>
        <Typography.Paragraph>
          {new URLSearchParams(window.location.search).get('waitlist') ===
          'true'
            ? 'If a seat becomes available you will be contacted.'
            : 'Thank you for your registration. You should have received a confirmation email. Please check your Spam folder if you did not receive the confirmation.'}
        </Typography.Paragraph>
      </Card>
    </div>
  )
}
